module.exports = __webpack_public_path__ + "img/small_t4_cors_nut.prt.a583c07c.jpg";